import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import navbarLogo from '@assets/svg/NavbarLogo.svg';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledSvgIcon = styled('img')(() => {
  return { height: '2.625rem' };
});

const StyledBox = styled(Box)(() => {
  return {
    display: 'flex',
    padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24} ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_4} 0`,
  };
});

const NavbarIcon_TsoPq = () => {
  return (
    <StyledBox>
      <StyledSvgIcon src={navbarLogo} data-testid="navbarLogo" />
    </StyledBox>
  );
};

export default NavbarIcon_TsoPq;
